// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"overview_wrapper__2H6ev","skeletonBlock":"overview_skeletonBlock__1zOJF","skeletonText":"overview_skeletonText__2lXOm"};